module.exports = __webpack_public_path__ + "img/CDNX/CDNX-favicon-32x32.png";